import { render, staticRenderFns } from "./CardSpecimenInventory.vue?vue&type=template&id=729e310c&scoped=true"
import script from "./CardSpecimenInventory.vue?vue&type=script&lang=js"
export * from "./CardSpecimenInventory.vue?vue&type=script&lang=js"
import style0 from "./CardSpecimenInventory.vue?vue&type=style&index=0&id=729e310c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729e310c",
  null
  
)

export default component.exports